<template>
  <div>
    <!--<div class="tips clearfix">
      
      <div class="containers">
        
        <div class="people clearfix fl">
          <div class="pic">
            <img src="http://web.wit100.net/yunmipcimg/school.jpg" alt srcset />
          </div>
          <div class="infos">
            <div class="name">周计刚</div>
            <div class="phones">13641541575</div>
          </div>
        </div>
        <div class="spanbox fr">
          <span>
            关注
            <i>100</i>
          </span>
          <span>
            收藏
            <i>100</i>
          </span>
          <span>
            学习时长
            <i>20h58分</i>
          </span>
        </div>
      </div>
    </div>-->
    <mytop class="tps"/>
    <div class="curriculum containers clearfix">
      <h3>课程评价</h3>
      <div class="pic">
        <img :src="$route.query.imgUrl" alt />
        <div class="type" v-if="$route.query.type == 1">点播课</div>
        <div class="type" v-if="$route.query.type == 2">直播课</div>
        <div class="type" v-if="$route.query.type == 3">线下课</div>
        <h5>{{$route.query.title}}</h5>
      </div>
      <div class="content">
        <div class="appraise">
          <div class="hum clearfix">
            <div class="name">课程评分</div>
            <div class="cowbox">
              <el-rate
                v-model="classstar"
                allow-half
                show-score
                text-color="#ff1c1c"
                :score-template="classstar.toString()"
              ></el-rate>
              <i>分</i>
            </div>
          </div>
          <div class="hum clearfix">
            <div class="name">评价内容</div>
            <div class="cowbox">
              <el-input
                type="textarea"
                placeholder="请输入内容"
                v-model="classvalue"
                maxlength="200字"
                show-word-limit
                class="textbox"
              ></el-input>
            </div>
          </div>
        </div>
        <div class="appraise">
          <div class="hum clearfix">
            <div class="name">讲师评分</div>
            <div class="cowbox">
              <el-rate
                v-model="teacherstar"
                allow-half
                show-score
                text-color="#ff1c1c"
                :score-template="teacherstar.toString()"
              ></el-rate>
              <i>分</i>
            </div>
          </div>
          <div class="hum clearfix">
            <div class="name">评价内容</div>
            <div class="cowbox">
              <el-input
                type="textarea"
                placeholder="请输入内容"
                v-model="teachervalue"
                maxlength="200字"
                show-word-limit
                class="textbox"
              ></el-input>
            </div>
          </div>
        </div>
        <div class="appraise">
          <div class="hum clearfix">
            <div class="name">机构评分</div>
            <div class="cowbox">
              <el-rate
                v-model="mechanismstar"
                allow-half
                show-score
                text-color="#ff1c1c"
                :score-template="mechanismstar.toString()"
              ></el-rate>
              <i>分</i>
            </div>
          </div>
          <div class="hum clearfix">
            <div class="name">评价内容</div>
            <div class="cowbox">
              <el-input
                type="textarea"
                placeholder="请输入内容"
                v-model="mechanismvalue"
                maxlength="200字"
                show-word-limit
                class="textbox"
              ></el-input>
            </div>
          </div>
        </div>
        <div class="hum clearfix">
          <div class="cowbox">
            <div class="spanx">
              <span class="on" @click="btn">保存</span>
              <span @click="back">取消</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="height:60px"></div>
    <footers />
  </div>
</template>

<script>
import headers from "@/components/header.vue";
import footers from "@/components/footer.vue";
import { Rate, Input, Message } from "element-ui";
import utilFile from "@/ace/ace.js";
import mytop from "@/components/mytop.vue";
export default {
  components: {
    headers,
    footers,
    mytop,
    [Rate.name]: Rate,
    [Input.name]: Input,
    [Message.name]: Message
  },
  data() {
    return {
      value: 3,
      text: "",
      textarea: "",

      classstar: 5,
      teacherstar: 5,
      mechanismstar: 5,

      classvalue: "",
      teachervalue: "",
      mechanismvalue: ""
    };
  },
  watch:{
    mechanismstar(newvalue){
      console.log(newvalue)
    }
  },
  methods: {
    back(){
      this.$router.back();
    },
    btn() {
      //首页数据请求
      var data = utilFile.encrypt(
        JSON.stringify({
          id: this.$route.query.id,
          courseScore: this.classstar,
          teacherScore: this.teacherstar,

          /*选填*/
          courseContent: this.classvalue,
          teacherContent: this.teachervalue,
          organizationScore: this.mechanismstar,
          organizationContent: this.mechanismvalue
        })
      );

      this.$axios({
        method: "post",
        url: `/api/user.courseComment?parameter=${data}`,
        data: {},
        withCredentials: true,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
        }
      }).then(res => {
        if (res.data.code == 90005) {
          Message.closeAll();
          Message({
            showClose: true,
            message: res.data.msg,
            type: "warning"
          });
        } else {
          Message.closeAll();
          Message({
            showClose: true,
            message: res.data.msg,
            type: "success"
          });
          setTimeout(() => {
            this.$router.back();
          }, 1000);
        }
      });
    }
  }
};
</script>

<style scoped>
@import "~@/assets/css/my.css";
.curriculum {
  margin-top: 38px;
  background-color: #ffffff;
  box-sizing: border-box;
  padding: 0 35px;
  overflow: hidden;
}
.curriculum h3 {
  text-align: left;
  font-size: 16px;
  color: #000000;
  line-height: 63px;
  border-bottom: 1px solid #edf1f2;
  margin-bottom: 31px;
}

.curriculum .pic {
  width: 210px;
  position: relative;
  float: left;
  border-radius: 6px;
  overflow: hidden;
}

.curriculum .pic .type {
  position: absolute;
  font-size: 14px;
  color: #ffffff;
  padding: 7px 12px;
  border-radius: 3px;
  background-color: rgba(0, 0, 0, 0.6);
  left: 10px;
  top: 10px;
}

.curriculum .pic h5 {
  text-align: center;
  box-sizing: border-box;
  padding: 0 20px;
  line-height: 1.5em;
  font-size: 18px;
  color: #000000;
  margin-top: 16px;
}

.content {
  width: 860px;
  float: right;
}

.content .hum {
  margin-bottom: 38px;
}

.content .hum .name {
  float: left;
  width: 137px;
  text-align: left;
  font-size: 20px;
  color: #000000;
}

.content .hum .cowbox {
  float: left;
  width: 719px;
  text-align: left;
}

.content .hum .cowbox span {
  float: left;
  font-size: 18px;
  color: #000000;
  width: 113px;
  height: 44px;
  border-radius: 50px;
  text-align: center;
  border: 1px solid #000;
  box-sizing: border-box;
  line-height: 44px;
  margin-right: 20px;
}

.content .hum .cowbox span.on {
  background-color: #38a0ff;
  color: #fff;
  border: 1px solid #fff;
}

.content .el-rate {
  text-align: left;
  float: left;
}

.content .appraise {
  padding-bottom: 12px;
  border-bottom: 1px solid #edf1f2;
  margin-bottom: 50px;
}

.content .appraise i {
  font-size: 16px;
  color: red;
  font-weight: bold;
  margin-left: 3px;
}
.content .spanx {
  box-sizing: border-box;
  padding-left: 137px;
  cursor: pointer;
}

</style>
<style>
.tps .tips{
  top: 0
}
.content .el-rate__icon {
  font-size: 26px;
}

.el-rate__text {
  font-size: 24px;
  color: red;
  font-weight: bold;
}

.content .el-textarea__inner {
  height: 160px;
  min-height: none;
}
</style>